import React from "react";

import SqupLogoAllWhite from "@/assets/images/common/logo_all_white.png";

const LoadingUI = () => {
  return (
    <div className="LoadingUI" role="status" aria-live="polite">
      <div className="loading-content">
        <img
          className="loading-logo"
          src={SqupLogoAllWhite}
          alt="SQUP 2026 로고 입니다."
        />

        <div className="loading-progress" aria-hidden="true">
          <span />
        </div>
      </div>
    </div>
  );
};

export default LoadingUI;
